import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
const included = ['6 Specialized Clinical Volumes', '+250 Clinical Protocols', '7-Step Diagnostic Framework', '+50 Tools & Resources', '5 Exclusive Bonuses', 'Lifetime Access', '7-Day Guarantee'];
export function FinalCTA() {
  return <section className="w-full bg-navy-900 px-4 py-14 text-white sm:px-6 sm:py-20" data-id="element-94" data-mp="3dt3o9nhbmutq">
      <div className="mx-auto w-full max-w-2xl" data-id="element-95" data-mp="3dvgbaf1xrvdn">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-gold-400" data-id="element-96" data-mp="3hvqfpna2ydqe">
          🦷 Your next dental case could be the first one you approach differently
        </p>
        <h2 className="mt-4 text-center font-display text-[28px] font-bold leading-[1.15] sm:text-4xl" data-id="element-97" data-mp="38v22gusighek">
          Stop Looking at a Dental Case and Wondering, “What Should I Evaluate First?”
        </h2>
        <div className="mx-auto mt-5 max-w-xl space-y-3 text-center text-[14.5px] leading-relaxed text-white/70" data-id="element-98" data-mp="171kyq27i40p3">
          <p data-id="element-99" data-mp="q72daym2br1n">
            Use the 7-step framework to structure your diagnostic process, identify what matters,
            establish priorities and know what to evaluate next.
          </p>
          <p data-id="element-100" data-mp="yznjzgcf67a4">
            You don’t need to rely on memory alone. You don’t need to start from zero with every
            patient. And you don’t need to spend hours organizing every piece of information before
            making a decision.
          </p>
          <p className="font-display text-xl italic text-gold-300" data-id="element-101" data-mp="2ay05kh8f4li">You need a system.</p>
        </div>

        <div className="mt-9 rounded-3xl border-2 border-gold-500 bg-navy-950 p-5 sm:p-8" data-id="element-102" data-mp="ga7ioqswuasn">
          <p className="text-center font-display text-xl font-bold sm:text-2xl" data-id="element-103" data-mp="bbcqwzcytbwe">
            Clinical Master System™ for Dental Diagnosis
          </p>
          <ul className="mt-5 grid gap-2.5 sm:grid-cols-2" data-id="element-104" data-mp="1ro1h7tvoozkm">
            {included.map(item => <li key={item} className="flex items-start gap-2 text-[14px] text-white/80" data-id="element-105" data-mp="1mpzyxb6314a7">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-400" aria-hidden="true" data-id="element-106" data-mp="kcbvwz96corj" />
                {item}
              </li>)}
          </ul>

          <div className="mt-6 border-t border-white/10 pt-5 text-center" data-id="element-107" data-mp="tda3fritneev">
            <p className="text-[13px] font-bold uppercase tracking-[0.14em] text-white/50 line-through" data-id="element-108" data-mp="ycwdxt79mgjz">
              Total Value: $414 USD
            </p>
            <p className="mt-1.5 font-display text-5xl font-bold text-gold-400 sm:text-6xl" data-id="element-109" data-mp="1o6wu53gprz2">
              $27 USD
            </p>
            <p className="mt-2 text-[12px] font-bold uppercase tracking-[0.12em] text-white/60" data-id="element-110" data-mp="5luu3esmnwu4">
              One-Time Payment • Lifetime Access • Instant Download
            </p>
          </div>

          <div className="mt-6" data-id="element-111" data-mp="ffv7s51z6aeg">
            <CTAButton label="Yes, I want the Clinical Master System" data-id="element-112" data-mp="3e4kc1ry0mf4d" />
          </div>

          <div className="mt-6" data-id="element-113" data-mp="3j2u7m3nnjhqi">
            <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-white/55" data-id="element-114" data-mp="3j22c0su21k08">
              The offer ends in
            </p>
            <Countdown className="mt-3" data-id="element-115" data-mp="36ki1dd9bkj4k" />
          </div>

          <p className="mt-5 text-center text-[12px] text-white/50" data-id="element-116" data-mp="36l1961599r4v">
            Currency conversion is automatic based on your country • Secure payment
          </p>
        </div>
      </div>
    </section>;
}